module.exports = __webpack_public_path__ + "img/text.a3c598c5.png";